// @flow

import React from 'react';
import { Segment, Label, Icon } from 'semantic-ui-react';

type Props = {
  files: Array<File>,
  onRemoveFile: (file: File) => void,
};

const UploadFileList = ({ files, onRemoveFile }: Props) => {
  if (files.length > 0) {
    return (
      <Segment>
        {files.map(file => (
          <Label key={file.name}>
            {file.name}
            <Icon name="delete" onClick={() => onRemoveFile(file)} />
          </Label>
        ))}
      </Segment>
    );
  } else {
    return null;
  }
};

export default UploadFileList;



// WEBPACK FOOTER //
// ./src/modules/messaging/components/messages/UploadFileList.js